import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["classes", "arrows", "children", "dotPanelType", "dotsView", "autoplaySpeed", "autoplay", "arrowsView", "arrowsInverted", "arrowsInside", "showHalfNextSlide", "customSlide", "responsive", "slidesToShow", "slidesToScroll", "speed", "nextArrow", "prevArrow", "appendDots", "customPaging", "arrowProps", "dotProps", "dotsPanelProps", "slideProps"];
import React, { Children, forwardRef } from 'react';
import SlickSlider from 'react-slick';
import classNames from 'classnames/bind';
import { Arrow } from './components/Arrow';
import { Dot } from './components/Dot';
import { DotsPanel } from './components/DotsPanel';
import { Slide } from './components/Slide';
import styles from './Slider.css';
import './slick-carousel.css';
var cx = classNames.bind(styles);
export var Slider = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$classes = _ref.classes,
      classes = _ref$classes === void 0 ? {} : _ref$classes,
      _ref$arrows = _ref.arrows,
      arrows = _ref$arrows === void 0 ? false : _ref$arrows,
      children = _ref.children,
      _ref$dotPanelType = _ref.dotPanelType,
      dotPanelType = _ref$dotPanelType === void 0 ? 'slider' : _ref$dotPanelType,
      _ref$dotsView = _ref.dotsView,
      dotsView = _ref$dotsView === void 0 ? 'light' : _ref$dotsView,
      _ref$autoplaySpeed = _ref.autoplaySpeed,
      autoplaySpeed = _ref$autoplaySpeed === void 0 ? 3500 : _ref$autoplaySpeed,
      _ref$autoplay = _ref.autoplay,
      autoplay = _ref$autoplay === void 0 ? false : _ref$autoplay,
      _ref$arrowsView = _ref.arrowsView,
      arrowsView = _ref$arrowsView === void 0 ? 'light' : _ref$arrowsView,
      _ref$arrowsInverted = _ref.arrowsInverted,
      arrowsInverted = _ref$arrowsInverted === void 0 ? false : _ref$arrowsInverted,
      _ref$arrowsInside = _ref.arrowsInside,
      arrowsInside = _ref$arrowsInside === void 0 ? false : _ref$arrowsInside,
      _ref$showHalfNextSlid = _ref.showHalfNextSlide,
      showHalfNextSlide = _ref$showHalfNextSlid === void 0 ? true : _ref$showHalfNextSlid,
      customSlide = _ref.customSlide,
      _ref$responsive = _ref.responsive,
      responsive = _ref$responsive === void 0 ? [{
    breakpoint: 767,
    settings: {
      arrows: false,
      centerMode: true
    }
  }] : _ref$responsive,
      _ref$slidesToShow = _ref.slidesToShow,
      slidesToShow = _ref$slidesToShow === void 0 ? 1 : _ref$slidesToShow,
      _ref$slidesToScroll = _ref.slidesToScroll,
      slidesToScroll = _ref$slidesToScroll === void 0 ? 1 : _ref$slidesToScroll,
      _ref$speed = _ref.speed,
      speed = _ref$speed === void 0 ? 500 : _ref$speed,
      _ref$nextArrow = _ref.nextArrow,
      nextArrow = _ref$nextArrow === void 0 ? null : _ref$nextArrow,
      _ref$prevArrow = _ref.prevArrow,
      prevArrow = _ref$prevArrow === void 0 ? null : _ref$prevArrow,
      _ref$appendDots = _ref.appendDots,
      appendDots = _ref$appendDots === void 0 ? null : _ref$appendDots,
      _ref$customPaging = _ref.customPaging,
      customPaging = _ref$customPaging === void 0 ? null : _ref$customPaging,
      arrowProps = _ref.arrowProps,
      dotProps = _ref.dotProps,
      dotsPanelProps = _ref.dotsPanelProps,
      slideProps = _ref.slideProps,
      props = _objectWithoutProperties(_ref, _excluded);

  var arrow = /*#__PURE__*/React.createElement(Arrow, _extends({
    view: arrowsView,
    inverted: arrowsInverted,
    inside: arrowsInside
  }, arrowProps));
  var Element = customSlide || Slide;
  return /*#__PURE__*/React.createElement(SlickSlider, _extends({}, props, {
    className: cx({
      arrows_inside: arrowsInside,
      show_half: showHalfNextSlide
    }, classes.root),
    arrows: arrows,
    nextArrow: nextArrow || arrow,
    prevArrow: prevArrow || arrow,
    appendDots: appendDots || function (dots) {
      return /*#__PURE__*/React.createElement(DotsPanel, _extends({
        type: dotPanelType
      }, dotsPanelProps), dots);
    },
    customPaging: customPaging || function () {
      return /*#__PURE__*/React.createElement(Dot, _extends({
        type: dotPanelType,
        duration: autoplaySpeed,
        autoplay: autoplay,
        view: dotsView
      }, dotProps));
    },
    autoplaySpeed: autoplaySpeed,
    autoplay: autoplay,
    responsive: responsive,
    slidesToShow: slidesToShow,
    slidesToScroll: slidesToScroll,
    speed: speed,
    ref: ref
  }), Children.map(children, function (item) {
    return /*#__PURE__*/React.createElement(Element, slideProps, item);
  }));
});